export const iconGroupStackStyles = {
  gap: '8px',
};
